import { render, staticRenderFns } from "./checkup-results-barchart.vue?vue&type=template&id=4d5f4298&scoped=true&"
import script from "./checkup-results-barchart.vue?vue&type=script&lang=js&"
export * from "./checkup-results-barchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5f4298",
  null
  
)

export default component.exports